var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZip = function SvgZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.69,
    height: 19.81,
    fill: "none",
    viewBox: "0 0 500 183"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AA8FFF",
    d: "M170.552 55.742 186.194 183h152.948L323.5 55.742z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A0826",
    d: "M214.184 7.18c9.755 9.17 11.093 23.594 2.988 32.217-8.104 8.622-22.582 8.178-32.337-.993-9.755-9.17-11.093-23.595-2.989-32.217 8.105-8.622 22.583-8.178 32.338.993"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A0826",
    fillRule: "evenodd",
    d: "M499.434 101.565c-3.521-28.62-26.003-45.924-56.532-45.823H341.204L356.846 183h45.769l-3.118-25.452h48.434c38.074 0 55.527-23.741 51.503-55.983m-56.482 20.321-47.881.05-3.772-30.532 48.132.05c11.317.151 17.101 6.49 18.057 15.241.603 5.584-1.962 15.191-14.536 15.191",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A0826",
    d: "M11.266 147.438 15.642 183H168.44l-5.03-40.692H92.192l-.654-5.081 65.635-45.823-4.375-35.662H0l4.98 40.743h71.369l.653 5.08z"
  })));
};
export default SvgZip;